<div class="annual-plan-dialog-form-phase">
     <form [formGroup]="assignPlanForm">
        <h1 mat-dialog-title>
            {{ data.dialogTitle | translate}}
        </h1>
        <div mat-dialog-content>
            <fieldset [disabled]="isSubmitting">
                <div class="line">
                    <mat-form-field color="primary">
                        <mat-select placeholder="{{ 'Athlete' | translate }}" formControlName="athlete">
                            <mat-option *ngFor="let row of rows" [value]="row.athlete">
                                {{ row.user.firstName }} {{ row.user.lastName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
<!--                        <mat-label class="required">{{ 'AnnualPlanStartedAt' | translate }}</mat-label>-->
                        <input matInput
                               [formControl]="startedAtControl"
                               [matDatepicker]="pickerStartedAt"
                               autocomplete="off">
                        <mat-error *ngIf="f['startedAt'].errors && f['startedAt'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                        <mat-datepicker-toggle matSuffix [for]="pickerStartedAt"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStartedAt startView="year" [startAt]="startDate"></mat-datepicker>
                    </mat-form-field>
                </div>
            </fieldset>
        </div>
        <mat-dialog-actions>

            <button mat-button mat-dialog-close tabindex="-1">
                {{ 'Cancel' | translate}}
            </button>

            <button mat-raised-button (click)="submitForm()" color="accent">
                {{ 'Assign' | translate}}
            </button>

        </mat-dialog-actions>
    </form>
</div>
